<template>
  <Component
    :is="'b-pagination'"
    class="rs-pagination"
    :value="value.currentPage || 1"
    :total-rows="value.totalRecords"
    :per-page="value.recordsPerPage"
    page-class="page-item--normal"
    @change="handlePageChange"
  >
    <template #first-text>
      <RsIcon
        icon="chevron-double-left"
        weight="far"
      />
    </template>
    <template #prev-text>
      <RsIcon
        icon="chevron-left"
        weight="far"
      />
    </template>
    <template #next-text>
      <RsIcon
        icon="chevron-right"
        weight="far"
      />
    </template>
    <template #last-text>
      <RsIcon
        icon="chevron-double-right"
        weight="far"
      />
    </template>
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IPageRange } from '@/shared';

export default defineComponent({
  name: 'RsPagination',

  props: {
    value: {
      type: Object as () => IPageRange,
      default: () => ({
        recordsPerPage: 20,
        totalPages: 0,
        currentPage: 1,
        totalRecords: 0,
      } as IPageRange),
    },
  },
  methods: {
    handlePageChange(e: any) {
      this.$emit('input', { ...this.value, ...{ currentPage: e } });
    },
  },
});
</script>

<style lang="scss">
  @import '@/styles/_variables.scss';
  $gray: #8694B3;
  .rs-pagination{
    .page-item{
      margin: 0 0.5rem 0 0;
      .page-link{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        min-width: 32px;
        height: 32px;
        border-radius: 3px;
        border: none;
        color: $gray;
        background-color: rgba($gray, 0.1);
        transition: background-color 0.2s ease;
        &:hover{
          background-color: rgba($gray, 0.2);
        }
        &:focus{
          box-shadow: none;
        }
      }

      &.disabled{
        border-radius: 3px;
        background-color: rgba($gray, 0.1);

        .page-link {
          background-color: rgba($gray, 0.1);
        }
      }

      &--normal{
        .page-link{
          border-radius: 3px;
          background-color: rgba($gray, 0.1);
        }
        &.active{
          border-radius: 3px;
          .page-link{
            background-color: $secondary-color;
            border-color: $secondary-color;
            color: $white;
          }
        }
      }
    }
    .rs-icon{
      font-size: 12px;
      color: rgba($tertiary-muted, 0.4);
    }
  }
</style>
